<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             :title="title"
             @open="open"
             @closed="closed"
             width="1100px">
    <div style="margin: 20px 70px 0 40px">
      <div style="margin-bottom: 20px">
        <el-input prefix-icon="el-icon-search" clearable v-model="filter.searchText" style="width: 260px"
                  placeholder="商品名称、编号"></el-input>
        <label style="margin-left: 12px; margin-right: 8px">供应商</label>
        <remote-select v-model="filter.supplierCode" class-name="SUPPLIER" using-code select-all></remote-select>
      </div>
      <el-table :data="goodsList" class="table-border" header-cell-class-name="table-head" max-height="600">
        <el-table-column>
          <template #header>
            <el-checkbox v-model="selected" @change="selectAll"></el-checkbox>
          </template>
          <template #default="{ row }">
            <el-checkbox v-model="row.selected" @change="selectedRow"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column label="商品名称" prop="name"></el-table-column>
        <el-table-column label="商品编号" prop="code"></el-table-column>
        <el-table-column label="保质期天数" prop="expireDaysFromNow"></el-table-column>
        <el-table-column label="单位" prop="unit">
          <template #default="{ row }">
            <div v-if="!row.selected || !row.unit2">{{ row.unit }}</div>
            <el-select v-else v-model="row.selectedUnit">
              <el-option :key="row.unit" :label="row.unit" :value="row.unit"></el-option>
              <el-option :key="row.unit2" :label="row.unit2" :value="row.unit2"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="库存数量" prop="remain">
          <template #default="{ row }">
            <div v-if="row.selectedUnit && row.selectedUnit == row.unit2">{{ row.remain * row.unitRatio }}</div>
            <div v-else>{{ row.remain }}</div>
          </template>
        </el-table-column>
        <el-table-column label="数量" prop="num" width="110">
          <template #default="{ row }">
            <div v-if="!row.selected"></div>
            <el-input-number v-else v-model="row.num" style="width: 90px"
                             controls-position="right"
                             :step="0.001"
                             :min="0"
                             step-strictly>
            </el-input-number>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <template #footer>
      <el-button type="primary" @click="confirm()">确 认</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>

import { valueName } from '@/utils/filters'
import RemoteSelect from '@/components/selector/RemoteSelect'

export default {
  name: 'SelectOutGoodsDialog',
  components: { RemoteSelect },
  props: {
    outbound: {
      type: Object,
      required: true
    },
    readOnly: Boolean,
    candGoodsList: Array
  },
  data () {
    return {
      selected: false,
      filter: {
        searchText: null,
        supplierCode: null
      },
      tf: true
    }
  },
  created () {
    this.$store.dispatch('data/kvList', 'SUPPLIER')
  },
  methods: {
    open () {
    },
    closed () {
    },
    confirm () {
      this.check()
      for (const item of this.goodsList) {
        if (!item.selected) continue
        if (item.num === 0) {
          this.$alert(`请填写 ${item.name} 的数量`)
          return
        }
        let remain = item.remain
        if (item.selectedUnit && item.selectedUnit === item.unit2) {
          remain = item.remain * item.unitRatio
        }
        if (item.num > remain) {
          this.$alert(` ${item.name} 的库存不足`)
          return
        }
      }
      this.$emit('update', this.goodsList.filter(item => item.selected))
      this.hide()
    },
    cancel () {
      this.hide()
    },
    hide () {
      this.$emit('update:visible', false)
    },
    selectAll () {
      for (const item of this.goodsList) {
        item.selected = this.selected
      }
    },
    selectedRow () {
      for (const item of this.goodsList) {
        if (item.selected) {
          this.outbound.goodsList.push(item)
        } else {
          for (const info of this.outbound.goodsList) {
            if (item.id === info.id) {
              this.outbound.goodsList.splice(info.index, 1)
            }
          }
        }
      }
    },
    check () {
      for (const info of this.outbound.goodsList) {
        if (info.num !== 0) {
          for (const itme of this.goodsList) {
            if (info.id === itme.id) {
              this.tf = false
            }
          }
          if (this.tf) {
            this.goodsList.push(info)
          }
        }
      }
    }
  },
  computed: {
    isNew () {
      return !this.outbound.id
    },
    controlReadOnly () {
      return !this.isNew && this.readOnly
    },
    title () {
      if (this.isNew) return '新增出库'
      return this.readOnly ? '出库详细信息' : '编辑出库'
    },
    goodsList () {
      const goodsIdMap = {}
      for (const goods of this.outbound.goodsList) {
        goodsIdMap[[goods.id, goods.inboundId]] = goods
      }

      if (!this.candGoodsList) return null
      let list = this.$_.cloneDeep(this.candGoodsList)
      for (const goods of list) {
        const selectedGoods = goodsIdMap[[goods.id, goods.inboundId]]
        if (selectedGoods) {
          this.$set(goods, 'selected', true)
          this.$set(goods, 'num', selectedGoods.num)
          this.$set(goods, 'selectedUnit', selectedGoods.selectedUnit)
        } else {
          this.$set(goods, 'selected', false)
          this.$set(goods, 'num', 0)
          this.$set(goods, 'selectedUnit', goods.unit)
        }
      }

      if (this.filter.searchText) {
        list = list.filter(item =>
          item.name.indexOf(this.filter.searchText) >= 0 ||
          item.code.indexOf(this.filter.searchText) >= 0 ||
          valueName(item.supplierCode, 'SUPPLIER').indexOf(this.filter.searchText) >= 0
        )
      }
      if (this.filter.supplierCode && this.filter.supplierCode !== -1) {
        list = list.filter(item => item.supplierCode === this.filter.supplierCode)
      }

      return list
    }
  }
}
</script>

<style scoped>

</style>
